jQuery(function ($) {
  // この中であればWordpressでも「$」が使用可能になる

  var topBtn = $(".to-top");
  topBtn.hide();

  // ボタンの表示設定
  $(window).scroll(function () {
    if ($(this).scrollTop() > 70) {
      // 指定px以上のスクロールでボタンを表示
      topBtn.fadeIn();
    } else {
      // 画面が指定pxより上ならボタンを非表示
      topBtn.fadeOut();
    }
  });

  // ボタンをクリックしたらスクロールして上に戻る
  topBtn.click(function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      300,
      "swing"
    );
    return false;
  });

  //ドロワーメニュー
  $("#MenuButton").click(function () {
    // $(".l-drawer-menu").toggleClass("is-show");
    // $(".p-drawer-menu").toggleClass("is-show");
    $(".js-drawer-open").toggleClass("open");
    $(".drawer-menu").toggleClass("open");
    $("html").toggleClass("is-fixed");
  });

  jQuery(function ($) {
    $(function () {
      $(".drawer-pc-price").on("click", function () {
        if ($(this).prop("checked")) {
          // 一旦全てをクリアして再チェックする
          $(".drawer-pc-price").prop("checked", false);
          $(this).prop("checked", true);
        }
      });
    });
  });

  jQuery(function ($) {
    $(function () {
      $(".drawer-pc-stock").on("click", function () {
        if ($(this).prop("checked")) {
          // 一旦全てをクリアして再チェックする
          $(".drawer-pc-stock").prop("checked", false);
          $(this).prop("checked", true);
        }
      });
    });
  });

  $(".product-list__column01").on("click", function (e) {
    e.preventDefault();
    $(".card").addClass("is-active");
    $(".product-list__column01").addClass("is-active");
    $(".product-list__column02").addClass("is-active");
    return false;
  });

  $(".product-list__column02").on("click", function (e) {
    e.preventDefault();
    $(".card").removeClass("is-active");
    $(".product-list__column01").removeClass("is-active");
    $(".product-list__column02").removeClass("is-active");
    return false;
  });

  jQuery(".drawer-pc__input [type=button]").on("click", function (e) {
    e.preventDefault();
    jQuery(".drawer-pc__input [type=button]").removeClass("is-active");
    jQuery(this).addClass("is-active");
    return false;
  });

  //サムネイル
  var thumbs = new Swiper(".js-thumbs-swiper", {
    slidesPerView: "auto",
    spaceBetween: 10,
    centeredSlides: false,
    slideToClickedSlide: true,
    a11y: false,
    freeMode: {
      enabled: true,
      momentumBounce: false,
      momentumRatio: 0.5,
      momentumVelocityRatio: 0.5,
      momentumBounceRatio: 0.5
    },
    breakpoints: {
      767: {
        spaceBetween: 0,
        freeMode: false
      },
    },
  });

  var swiper = new Swiper(".js-gallery-swiper", {
    slidesPerView: 1,
    centeredSlides: false,
    loop: true,
    a11y: false,
    loopedSlides: 1, //スライドの枚数と同じ値を指定
    pagination: {
      el: ".swiper-pagination",
      type: "custom",
      renderCustom: function (_, current, total) {
        return `<span class="swiper-pagination-current">${current}</span>/<span class="swiper-pagination-total">${total}</span>`;
      },
    },
    on: {
      sliderMove: function () {
        if ($(window).width() < 768) {
          $('body').css('overflow', 'hidden');
        }
      },

      touchEnd: function () {
        if ($(window).width() < 768) {
          $('body').css('overflow', '');
        }
      },

      slideChangeTransitionEnd: function () {
        if ($(window).width() < 768) {
          $('body').css('overflow', '');
        }
      }
    },
    navigation: {
      nextEl: ".swiper-next",
      prevEl: ".swiper-prev",
    },
    thumbs: {
      swiper: thumbs,
    },
  });
  var prevarrow = $('.swiper-prev');
  var nextarrow = $('.swiper-next'); 
  if(swiper.slides.length > 1){
    prevarrow.css('display', 'block');
    nextarrow.css('display', 'block');
  }else{
    prevarrow.css('display', 'none');
    nextarrow.css('display', 'none');
  }
  
  // swiper.on('slideChange', function() {
  //   var realIndex = swiper.realIndex;
  //   var activeIndex = swiper.slides.length - 1;
  //   realIndex == 0 ? prevarrow.css('display', 'none') : prevarrow.css('display', 'block');
  //   realIndex == activeIndex ? nextarrow.css('display', 'none') : nextarrow.css('display', 'block');
  // });

  var slider = new Swiper(".styling__items", {
    slidesPerView: "auto",
    spaceBetween: 10,
    slidesPerView: 2.5,
    //centeredSlides: true,
    loop: true,
    a11y: false,
    loopedSlides: 6, //スライドの枚数と同じ値を指定
  });

  //4系～
  //メインとサムネイルを紐づける
  //slider.controller.control = thumbs;
  //thumbs.controller.control = slider;

  jQuery(window).on("scroll", function () {
    // トップから100px以上スクロールしたら
    if (100 < jQuery(this).scrollTop()) {
      // is-showクラスをつける
      jQuery(".to-top").addClass("is-show");
    } else {
      // 100pxを下回ったらis-showクラスを削除
      jQuery(".to-top").removeClass("is-show");
    }
  });

  if (window.matchMedia("(max-width: 694px)").matches) {
  } else {
    jQuery(window).on("scroll", function () {
      // トップから100px以上スクロールしたら
      if (100 < jQuery(this).scrollTop()) {
        // is-showクラスをつける
        jQuery(".product-list__header").addClass("fixed");
        jQuery(".product-list__items").addClass("is-active");
      } else {
        // 100pxを下回ったらis-showクラスを削除
        jQuery(".product-list__header").removeClass("fixed");
        jQuery(".product-list__items").removeClass("is-active");
      }
    });
  }
});


jQuery(function () {
  const Select = jQuery(".is-select");
  jQuery(Select).on("change", function () {
    if (jQuery(Select).val() !== "") {
      jQuery(this).removeClass("is-select");
    } else {
      jQuery(this).addClass("is-select");
    }
  });
});

jQuery(function () {
  // 変数に要素を入れる
  var open = $(".guide_modal-open"),
    open2 = $(".guide_modal-open_pc"),
    close = $(".guide_modal-close"),
    container = $(".guide_modal-container");

  //開くボタンをクリックしたらモーダルを表示する
  open.on("click", function () {
    container.addClass("active");
    return false;
  });

  open2.on("click", function () {
    container.addClass("active");
    return false;
  });

  //閉じるボタンをクリックしたらモーダルを閉じる
  close.on("click", function () {
    container.removeClass("active");
  });

  //モーダルの外側をクリックしたらモーダルを閉じる
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".guide_modal-body").length) {
      container.removeClass("active");
    }
  });
});

  /// クリック（タブ）
$(function (){
    $(".tab__nav ul li span").click(function (e) {
        e.preventDefault();
        var page = $('main').data('page');
        if(page === "BM_WISHLIST") {

          var tabname = $(this).data('tabname');
          var urlParams = window.location.href.split('?type=')[0];
          urlParams = urlParams + '?type=' +tabname;
          history.pushState(null, '', urlParams);
          location.reload();

        } else {
          let target = jQuery(this).data("target");
          $(".tab__nav ul li span").removeClass("is-active");
          $(this).addClass("is-active");

          $(".tab-item").removeClass("is-active");
          $(target).addClass("is-active");  
        }
        return false;
      });
} )

$(document).on('DOMNodeInserted', function(e) {
    if(e.target.className === 'vue-portal-target'){
        $('#tab-item02 .grad-btn').css('display', 'block');
        $('#tab-item02 .grad-btn').css('height', '');
    }
});    

$(".header__icon_wishlist").click(function () { 
  var wishlisturl = $(this).attr("data-wishlisturl");
  localStorage.setItem('currenturl', window.location.href);
  window.location.href = wishlisturl;
})

jQuery(document).ready(function($) {
  var page = $('main').data('page');
  if(page === "BM_WISHLIST") {
      if (window.history && window.history.pushState) {
        $(window).on('popstate', function() {
             var url = localStorage.getItem('currenturl');
             if(url && url != '') {
                  window.location.href = url;
             }
        });
      }
  }
});

$(function () {
  // 「.size_modal_open」をクリックしたらモーダルと黒い背景を表示する
  $(".js-size_modal_btn").click(function () {
    // 黒い背景をbody内に追加
    $("body").append('<div class="size_modal_bg"></div>');
    $("body").addClass("is-open");
    $(".size_modal_bg").fadeIn();
    // data-targetの内容をIDにしてmodalに代入
    var size_modal = "#" + $(this).attr("data-target");
    $(size_modal).addClass("is-active");
    // size_modalをフェードインで表示
    $(size_modal).fadeIn();
    // .size_modal_bgか.size_modal_closeをクリックしたらモーダルと背景をフェードアウトさせる
    $(".size_modal_bg, .size_modal_close")
      .off()
      .click(function () {
        $(".size_modal").fadeOut();
        $(size_modal).removeClass("is-active");
        $(".size_modal_bg").fadeOut("slow", function () {
          $(".size_modal_bg").remove();
        });
        $("body").removeClass("is-open");
      });
    // .size_modal_switchを押すとモーダルを切り替える
    $(".size_modal_switch").click(function () {
      // 押された.modal_switchの親要素の.modalをフェードアウトさせる
      $(this).parents(".size_modal").fadeOut();
    });
  });

});

$(function () {
    //Get user info from data layer
    var HeaderDataLayer = $('input[name="dataLayer"]').val();
    if (HeaderDataLayer) {
        HeaderDataLayer = JSON.parse(HeaderDataLayer);
    }
    $(document).on("click",".cart_link_2", function(){
        $('.cart_item_mail_block').removeClass('active');
        $('.mail_done_text').removeClass('active');
        $('.mail_error_text').removeClass('active');
        $('.message_error_text').removeClass('active');
        $(this).parent().next().toggleClass('active');
    });
    $(document).on("click",".cart_item_mail_block .cart_modal_close_2", function(){
        var authenticated = $(this).data('auth');
        $(this).parent().toggleClass('active');
        $('.mail_done_text').removeClass('active');
        if(!authenticated){
            $('.cart_item_mail_text').val('');
        }
        $('.mail_error_text').removeClass('active');
        $('.message_error_text').removeClass('active');
      });
    $(document).on("click", ".cart_item_mail_submit", function(e){
        $('.mail_error_text').removeClass('active')
        $('.mail_done_text').removeClass('active');
        $('.message_error_text').removeClass('active');

        var url = $(this).siblings('.cart_item_mail_text').parent().attr('data-url');
        var pid = $(this).siblings('.cart_item_mail_text').parent().attr('data-pid');
        var cid = $(this).siblings('.cart_item_mail_text').parent().attr('data-cid') || undefined;
        var email = $(this).siblings('.cart_item_mail_text').val();
        if (!email) {
            $('.mail_error_text').addClass('active')
        }
        else {
            var form ={
              email : email,
              pid: pid,
              cid: cid
            };
            
            $.ajax({
                url: url,
                method: "POST",
                data: form,
                success: function (data) {
                    if (data.success){
                        $('.mail_done_text').html(data.message);
                        $('.mail_done_text').addClass('active');

                        var productDataLayer = data.productDataLayer;
                        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                        dataLayer.push({
                          user_id: HeaderDataLayer && HeaderDataLayer.user_properties ? CryptoJS.SHA256(HeaderDataLayer.user_properties.customer_id).toString(CryptoJS.enc.Hex) : '',
                          event: data.isComingSoon ? 'add_to_arrival_info' : 'add_to_restock_info' ,
                          ecommerce: {
                              currency: 'JPY',
                              value: productDataLayer.ecommerceValue,
                              items: productDataLayer.items
                          },
                          members_id: HeaderDataLayer && HeaderDataLayer.user_properties ? HeaderDataLayer.user_properties.customer_id : ''
                        });
                    } else{
                        $('.message_error_text').html(data.message);
                        $('.message_error_text').addClass('active');
                    }
                },
                error: function (err) {
                    $('.mail_error_text').html(err.message);
                    $('.mail_error_text').addClass('active');
                },
            });
        }
        
        
    });
  // 「.size_modal_open」をクリックしたらモーダルと黒い背景を表示する
  $(document).on('click', ".js-cart_modal_btn", function () {
    // 黒い背景をbody内に追加
    $("body").append('<div class="cart_modal_bg bg_cart"></div>');
    $("body").addClass("is-open");
    $('body').addClass('lock_scroll');
    $(".cart_modal_bg").fadeIn();
    // data-targetの内容をIDにしてmodalに代入
    var cart_modal = "#" + $(this).attr("data-target");
    $(cart_modal).addClass("is-active");
    // cart_modalをフェードインで表示
    $(cart_modal).fadeIn();
    // .cart_modal_bgか.cart_modal_closeをクリックしたらモーダルと背景をフェードアウトさせる
    $(document).on('click', '.cart_modal_bg, .cart_modal_close', function () {
        $(".cart_modal").fadeOut(function () {
          $('body').removeClass('lock_scroll');
        });
        $(cart_modal).removeClass("is-active");
        $(".cart_modal_bg").fadeOut("slow", function () {
          $(".cart_modal_bg").remove();
          $('body').removeClass('lock_scroll');
        });
        $("body").removeClass("is-open");
        $('html').css('overflow', 'initial').css('margin-right', '0').css('touch-action', '');
      });
    // .cart_modal_switchを押すとモーダルを切り替える
    $(".cart_modal_switch").click(function () {
      // 押された.modal_switchの親要素の.modalをフェードアウトさせる
      $(this).parents(".cart_modal").fadeOut();
    });
  });
});

$(function () {
  // 「.store_modal_open」をクリックしたらモーダルと黒い背景を表示する
  $(document).on('click',".js-store_modal_btn", function () {
    // 黒い背景をbody内に追加
    $('.store_modal_inner').css("overflow","scroll");
    $("body").append('<div class="store_modal_bg"></div>');
    $("body").addClass("is-open");
    $('body').addClass('lock_scroll');
    $(".store_modal_bg").fadeIn();
    // data-targetの内容をIDにしてmodalに代入
    var store_modal = "#" + $(this).attr("data-target");
    $(store_modal).addClass("is-active");
    // store_modalをフェードインで表示
    $(store_modal).fadeIn();
    // .store_modal_bgか.store_modal_closeをクリックしたらモーダルと背景をフェードアウトさせる
    $(".store_modal_bg, .store_modal_close")
      .off()
      .click(function () {
        $(".store_modal").fadeOut(function () {
          $('body').removeClass('lock_scroll');
        });
        $(store_modal).removeClass("is-active");
        $(".store_modal_bg").fadeOut("slow", function () {
          $(".store_modal_bg").remove();
          $('body').removeClass('lock_scroll');
        });
        $("body").removeClass("is-open");
        $('html').css('overflow', 'initial').css('margin-right', '0').css('touch-action', '');
      });
    // .store_modal_switchを押すとモーダルを切り替える
    $(".store_modal_switch").click(function () {
      // 押された.modal_switchの親要素の.modalをフェードアウトさせる
      $(this).parents(".store_modal").fadeOut();
    });
  });
});

$(document).mouseup(function(e) 
{
    var container = $(".cart_done ");
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        container.removeClass('active');
    }
});
